var _desc, _defs, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgCubismOn(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "30px",
    height: "30px",
    viewBox: "0 0 30 30",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "overlapping_on") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "Created with Sketch.")), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("rect", {
    id: "path-1",
    x: 0,
    y: 0,
    width: 16,
    height: 16,
    rx: 4
  }), /*#__PURE__*/React.createElement("rect", {
    id: "path-3",
    x: 0,
    y: 0,
    width: 16,
    height: 16,
    rx: 4
  }), /*#__PURE__*/React.createElement("rect", {
    id: "path-5",
    x: 0,
    y: 0,
    width: 16,
    height: 16,
    rx: 4
  }), /*#__PURE__*/React.createElement("rect", {
    id: "path-7",
    x: 0,
    y: 0,
    width: 16,
    height: 16,
    rx: 4
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "overlapping_on",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "scale---cubism---on",
    transform: "translate(7.000000, 7.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Mask",
    fill: "#4A90E2",
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "path-1",
    x: 0,
    y: 0,
    width: 16,
    height: 16,
    rx: 4
  })), /*#__PURE__*/React.createElement("g", {
    id: "Path-5-Clipped"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask-2",
    fill: "white"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#path-1"
  })), /*#__PURE__*/React.createElement("g", {
    id: "path-1"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Path-5",
    fill: "#FFFFFF",
    fillRule: "nonzero",
    opacity: 0.200000003,
    mask: "url(#mask-2)",
    points: "6.22222222 0.888888889 15.1111111 0.888888889 15.1111111 15.1111111 1.77777778 15.1111111"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Path-5-Clipped"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask-4",
    fill: "white"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#path-3"
  })), /*#__PURE__*/React.createElement("g", {
    id: "path-1"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Path-5",
    fill: "#FFFFFF",
    fillRule: "nonzero",
    opacity: 0.400000006,
    mask: "url(#mask-4)",
    points: "15.1111111 0.888888889 15.1111111 15.1111111 6.22222222 15.1111111 10.6666667 0.888888889"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Path-5-Clipped"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask-6",
    fill: "white"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#path-5"
  })), /*#__PURE__*/React.createElement("g", {
    id: "path-1"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Path-5",
    fill: "#FFFFFF",
    fillRule: "nonzero",
    opacity: 0.800000012,
    mask: "url(#mask-6)",
    points: "15.1111111 0.888888889 15.1111111 15.1111111 10.6666667 15.1111111"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Rectangle-Clipped"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask-8",
    fill: "white"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#path-7"
  })), /*#__PURE__*/React.createElement("g", {
    id: "path-1"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle",
    stroke: "#4A90E2",
    mask: "url(#mask-8)",
    x: 0.5,
    y: 0.5,
    width: 15,
    height: 15,
    rx: 4
  }))))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCubismOn);
export default __webpack_public_path__ + "static/media/cubism-on.185693ad038e56e3814b0a3e646fdf89.svg";
export { ForwardRef as ReactComponent };